export default "<a [class]=\"cssClass\"\n   [class._disabled]=\"disabled\">\n    <ng-content></ng-content>\n</a>\n";